var map = {
  "./strates/strate-snap/strate-snap.js": [
    "365",
    [
      286
    ]
  ],
  "./components/shares/shares.js": [
    "785",
    [
      440
    ]
  ],
  "./components/dialog/dialog.js": [
    "101",
    [
      676
    ]
  ],
  "./components/lottie/lottie.js": [
    "47",
    [
      366
    ]
  ],
  "./strates/strate-keynumbers/strate-keynumbers.js": [
    "977",
    [
      666
    ]
  ],
  "./components/field/field.js": [
    "243",
    [
      514
    ]
  ],
  "./components/figma-animate/figma-animate.js": [
    "7",
    [
      986
    ]
  ],
  "./components/marquee/marquee.js": [
    "387",
    [
      170
    ]
  ],
  "./components/autocomplete/autocomplete.js": [
    "713",
    [
      984
    ]
  ],
  "./components/accordion/accordion.js": [
    "575",
    [
      510
    ]
  ],
  "./components/slider/slider.js": [
    "751",
    [
      762
    ]
  ],
  "./components/video/video.js": [
    "303",
    [
      350
    ]
  ],
  "./strates/strate-highlighting/strate-highlighting.js": [
    "109",
    [
      129
    ]
  ],
  "./components/select-custom/select-custom.js": [
    "727",
    [
      886
    ]
  ],
  "./components/tooltip/tooltip.js": [
    "543",
    [
      678
    ]
  ],
  "./strates/strate-push_cards/strate-push_cards.js": [
    "165",
    [
      202
    ]
  ],
  "./strates/strate-strates-anchor/strate-push_contact.js": [
    "934",
    [
      543
    ]
  ],
  "./components/anchor-nav/anchor-nav.js": [
    "391",
    [
      402
    ]
  ],
  "./components/popover/popover.js": [
    "775",
    [
      890
    ]
  ],
  "./components/tab/tab.js": [
    "23",
    [
      450
    ]
  ],
  "./common/header-nav/header-nav.js": [
    "110",
    [
      61
    ]
  ],
  "./common/prefooter/prefooter.js": [
    "782",
    [
      153
    ]
  ],
  "./components/select-lang/select-lang.js": [
    "359",
    [
      486
    ]
  ],
  "./strates/strate-push_contact/strate-push_contact.js": [
    "993",
    [
      686
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 526;
module.exports = __rspack_async_context;
